import useOpenLink from './useOpenLink';

const useCardLinks = () => {
  const openExternalLink = useOpenLink();

  const openProductTerms = () => {
    openExternalLink('LinkUrls.CardTerms', 'MissingCardGeneralTermsUrl');
  };

  const openPriceList = () => {
    openExternalLink('LinkUrls.CardPriceList', 'MissingCardPriceListUrl');
  };

  const openGeneralTerms = () => {
    openExternalLink('LinkUrls.GeneralTerms', 'MissingCardBusinessTermsUrl');
  };

  return {
    openProductTerms,
    openPriceList,
    openGeneralTerms,
  };
};

export default useCardLinks;
